import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { CircularProgressBar } from '@/shared/ui/circularProgress'
import { Skeleton } from '@mui/material'
export const TasksSkeleton = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.tasks
  return (
    <div className={classes.root}>
      <div style={{ height: '220px' }} />
      <div className={classes.headingWrapper}>
        <h1>{texts.heading}</h1>
        <div className={classes.progressBar}>
          <div className={classes.circleBarWrapper}>
            <CircularProgressBar
              currentValue={0}
              maxValue={4}
              size="22px"
              thickness={7}
            />
          </div>
          <span className={classes.taskCountText}>{'0/0'}</span>
        </div>
      </div>
      <div style={{ width: '100%', padding: '0px 12px' }}>
        <Skeleton
          width={'100%'}
          height={32}
          style={{ borderRadius: '8px', marginTop: '24px' }}
        />
      </div>

      <div style={{ width: '100%', padding: '12px' }}>
        <div className={classes.tasksListWrapper}>
          <div className={classes.inGameTasksWrapper}>
            <span className={classes.sectionHeading}>{texts.inGame}</span>
            <Skeleton
              width={'100%'}
              height={98}
              style={{ borderRadius: '8px' }}
            />
            <Skeleton
              width={'100%'}
              height={158}
            />
          </div>
          <div className={classes.inGameTasksWrapper}>
            <span className={classes.sectionHeading}>{texts.dailyTasks}</span>
            <Skeleton
              width={'100%'}
              height={152}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
